import AImage from "./ExtendedObjects/AImage.js";
import AScene from "./ExtendedObjects/AScene.js";

export default class TouchableImage extends Phaser.Physics.Matter.Image
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, x, y, frame, origin = .5, interactiveCoords = null)
    {
        super(scene, x, y, scene.defaultAtlas, frame);

        this.scene.input.addPointer(10);

        this.prevTheta = 0;
        this.prevDist = 0;

        this.onScale = null;
        this.onRotate = null;
        this.onTranslate = null;
        this.interactiveCoords = interactiveCoords;

        if(interactiveCoords) this.setInteractive(new Phaser.Geom.Polygon(interactiveCoords), Phaser.Geom.Polygon.Contains);
        else this.setInteractive();

        this.pointers = this.getPointer();
        this.on('pointerdown', (pointer)=>{
            if(this.pointers.length >= 2) return;
            this.pointers.push(pointer);
            this.prevDist = this.deltaDistance;
            this.prevTheta = this.theta;
        });

        this.updateTransform = true;
    }

    /**
     * @returns {Phaser.Input.Pointer[]}
     */
    getPointer(){return [];}

    preUpdate()
    {
        for(let i = 0; i < this.pointers.length; i++)
        {
            if(!this.pointers[i].isDown || !this.pointers[i].active) this.pointers.splice(i, 1);
        }
        
        if(!this.updateTransform) return;
        this.calculateMovement();

        if(this.onTranslate != null) this.translate();
        if(this.onScale != null) this.scale();
        if(this.onRotate != null) this.rotate();

        this.prevDist = this.deltaDistance;
        this.prevTheta = this.theta;
    }

    calculateMovement()
    {
        let pointerCount = this.pointers.length;
        if(pointerCount <= 0) return;
        
        for(let i = 0; i < pointerCount; i++)
        {
            let pntr = this.pointers[i];

            pntr.movementX = pntr.downX - pntr.x;
            pntr.movementY = pntr.downY - pntr.y;
            pntr.downX = pntr.x;
            pntr.downY = pntr.y;
        }
    }

    translate()
    {
        if(this.pointers.length <= 0) return;
        let deltaMidpoint = this.deltaMidpoint;

        this.onTranslate(deltaMidpoint.x, deltaMidpoint.y);
    }

    rotate()
    {
        if(this.pointers.length <= 1) return;
        let deltaTheta = this.theta - this.prevTheta;

        this.onRotate(deltaTheta);
    }

    scale()
    {
        if(this.pointers.length <= 1) return;
        let deltaDistance = this.deltaDistance;
        let deltaScale = deltaDistance - this.prevDist;

        this.onScale(deltaScale);
    }

    get midPoint()
    {
        let pointsTotal = {x: 0, y: 0};
        let pointerCount = this.pointers.length;

        for(let i = 0; i < pointerCount; i++)
        {
            let pntr = this.pointers[i];
            pointsTotal.x += pntr.x;
            pointsTotal.y += pntr.y;
        }

        pointsTotal.x /= pointerCount;
        pointsTotal.y /= pointerCount;
            
        return pointsTotal;
    }

    get deltaDistance()
    {
        let dist = 0;
        let midPoint = this.midPoint;
        let pointerCount = this.pointers.length;

        for(let i = 0; i < pointerCount; i++)
        {
            let pntr = this.pointers[i];
            dist += this.hypot(pntr.x - midPoint.x, pntr.y - midPoint.y);
        }

        return (dist / pointerCount);
    }

    get midPoint()
    {
        let pointerCount = this.pointers.length;
        let midPoint = {x: 0, y: 0};
        
        for(let i = 0; i < pointerCount; i++)
        {
            let pntr = this.pointers[i];

            midPoint.x += pntr.x;
            midPoint.y += pntr.y;
        }

        midPoint.x /= pointerCount;
        midPoint.y /= pointerCount;

        return midPoint;
    }

    get deltaMidpoint()
    {
        let pointerCount = this.pointers.length;
        let deltaMid = {x: 0, y: 0};
        
        for(let i = 0; i < pointerCount; i++)
        {
            let pntr = this.pointers[i];

            deltaMid.x -= pntr.movementX;
            deltaMid.y -= pntr.movementY;
        }

        deltaMid.x /= pointerCount;
        deltaMid.y /= pointerCount;

        return deltaMid;
    }

    get theta()
    {
        let totalTheta = 0;
        let pointerCount = this.pointers.length;

        for(let i = 0; i < pointerCount - 1; i++)
        {
            let pos1 = this.pointers[i];
            let pos2 = this.pointers[i+1];

            totalTheta += Math.atan2(pos2.y - pos1.y, pos2.x - pos1.x);
        }

        return (totalTheta / (pointerCount - 1));
    }

    hypot() 
    {
        let y = 0;
        let i = arguments.length;
        while (i--) y += arguments[i] * arguments[i];
        return Math.sqrt(y);
    }
}